// Copyright: IQGeo Limited 2010-2019
import myw from 'myWorld/base/core';
import './numberFieldEditor';

/**
 * Editor for fields of type numeric<br/>
 * @name NumericFieldEditor
 * @constructor
 * @extends {NumberFieldEditor}
 */
myw.NumericFieldEditor = myw.NumberFieldEditor.extend({
    options: {
        unitValueOptions: { minimumFractionDigits: 0, maximumFractionDigits: 0 }
    },

    initialize(owner, feature, fieldDD, options) {
        this.fieldDD = fieldDD;
        this.calculateRange();
        myw.NumberFieldEditor.prototype.initialize.call(this, owner, feature, fieldDD, options);
    },

    /**
     * Update the min and the max limit using the precision and scale from the data type
     */
    calculateRange() {
        const // array with precision and scale from the data type
            ps = this.fieldDD.type.substring(8, 11).split(','); //String to store the maximum limit for the numeric field

        const // precision
            p = parseInt(ps[0], 10);

        const // scale
            s = parseInt(ps[1], 10);

        const integerDigitsAllowed = p - s;
        const decimalDigitsAllowed = s;
        let dbMaxStr = '';

        for (let i = 0; i < integerDigitsAllowed; i++) dbMaxStr += '9';

        if (decimalDigitsAllowed) {
            //Adds the digits after the decimal
            dbMaxStr += '.'; //Adds a decimal point
            for (let j = 0; j < decimalDigitsAllowed; j++) dbMaxStr += '9';
        }

        const dbMax = parseFloat(dbMaxStr, 10),
            dbMin = dbMax * -1,
            fieldMin = this.fieldDD.min_value,
            fieldMax = this.fieldDD.max_value;

        this.options.min_value =
            (fieldMin && fieldMin < dbMin) || typeof fieldMin === 'undefined' ? dbMin : fieldMin;

        this.options.max_value =
            (fieldMax && fieldMax > dbMax) || typeof fieldMax === 'undefined' ? dbMax : fieldMax;

        const unitValueFactionalDigits = decimalDigitsAllowed || 0;
        this.options.unitValueOptions.minimumFractionDigits = unitValueFactionalDigits;
        this.options.unitValueOptions.maximumFractionDigits = unitValueFactionalDigits;
    }
});

export default myw.NumericFieldEditor;
